import LongTextEllipsis from "./LongTextEllipsis";
export default LongTextEllipsis;
